import {
  ApiOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import styles from "./QuestionsToFlags.module.css";
import {
  Button,
  Divider,
  Input,
  Modal,
  Select,
  Skeleton,
  Space,
  Tag,
  message,
  Typography,
  Statistic,
  Row,
  Col,
  Table,
} from "antd";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import * as d3 from "d3";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/action";
import { editError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import Flags from "../../Flags/Flags";
import { getPlainLabel } from "../../../../Util/EpollParser";
import ExportExcel from "../../../../Util/ExportExcel";
import { saveAs } from "file-saver";
import CheckPermission from "../../../../Util/CheckPermission";
import { useNavigate, useParams } from "react-router-dom";
import { findFlagRef } from "../../UserRoadmap/UserRoadmap";

const QuestionsToFlagsLocal = ({
  LoadingSetter,
  ClearLoading,
  loading,
  flags,
  questionTypesData,
  permissions,
}) => {
  const params = useParams();
  const navigate = useNavigate();

  const [flagsStat, setFlagStat] = useState([]);
  const [flagsTag, setFlagsTag] = useState([]);
  const [formAdjectives, setFormAdjectives] = useState([]);
  const [ignoreTag, setIgnoreTags] = useState([]);
  const [ignoreFlags, setIgnoreFlags] = useState([]);
  const [tempFlagsIndex, setTempFlagsIndex] = useState([]);
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openIgnoreFlagModal, setOpenIgnoreFlagModal] = useState(false);
  const [editingRecord, setEditingRecord] = useState();
  const [allFlags, setAllFlags] = useState([]);
  const [formId, setFormId] = useState();
  const [editableKeys, setEditableRowKeys] = useState();
  const [questionTypes, setQuestionTypes] = useState([]);
  const [reportModal, setReportModal] = useState();
  const [reportData, setReportData] = useState([]);
  const [reportExportKey, setReportExportKey] = useState(null);
  const [newQuestionType, setNewQuestionType] = useState("");
  const newQuestionTypeInputRef = useRef(null);
  const [importantQuestions, setImportantQuestions] = useState([]);
  const [formReport, setFormReport] = useState(null);
  const [statisticsModal, setStatisticsModal] = useState(null);
  const pieChartRef = useRef(null);
  const [compareModal, setCompareModal] = useState(null);
  const [compareQuestionId, setCompareQuestionId] = useState();
  const [compareResult, setCompareResult] = useState(null);
  const [compareLoading, setCompareLoading] = useState(false);

  const adjectiveList = useMemo(
    () => Array.from(new Set(formAdjectives.map((e) => e.adjective))),
    [formAdjectives]
  );
  const selectableQuestions = useMemo(
    () =>
      data.filter(
        (q) => Array.isArray(q.children) && (q.children?.length ?? 0) > 0
      ),
    [data]
  );

  const changeFlagImportance = (importance, row, flagId) => {
    const termIndex = getFlagTermIndexVal(row, flagId);

    setTempFlagsIndex((prev) => {
      if (row.isOption) {
        const newArr = prev.filter(
          (i) =>
            !(
              i.answer_id === row.anwser_id &&
              i.id === row.id &&
              flagId === i.flagId
            )
        );

        return [
          ...newArr,
          {
            answer_id: row.anwser_id,
            id: row.id,
            flagId,
            value: termIndex,
            importance,
          },
        ];
      } else {
        const newArr = prev.filter(
          (i) =>
            !(i.id === row.id && flagId === i.flagId && i.answer_id === null)
        );

        return [
          ...newArr,
          {
            id: row.id,
            flagId,
            value: termIndex,
            importance,
          },
        ];
      }
    });
  };

  const getFlagImportance = (row, flagId) => {
    if (row.isOption) {
      const exists = tempFlagsIndex.find(
        (i) =>
          i.id === row.id &&
          i.answer_id === row.anwser_id &&
          i.flagId === flagId
      );

      return exists?.importance ?? 0;
    } else {
      let exists = tempFlagsIndex.find(
        // (i) => i.answer_id === row.id && i.flagId === flagId && !i.id
        (i) => i.id === row.id && i.flagId === flagId && !i.answer_id
      );
      if (!exists) {
        exists = tempFlagsIndex.find(
          (i) => i.answer_id === row.id && i.flagId === flagId && !i.id
        );
      }

      return exists?.importance ?? 0;
    }
  };

  const flagsMapper = (ids, row, editing = false) => {
    if (Array.isArray(allFlags) && allFlags.length > 0) {
      if (Array.isArray(ids)) {
        return ids.map((id) => {
          let element = null;

          allFlags.forEach((flag) => {
            if (id === flag.id) {
              const stat = getFlagSta(flag.id);

              element = (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.05)",
                    minHeight: "3rem",
                    paddingLeft: "0.5rem",
                    paddingRight: "0.5rem",
                  }}
                >
                  {/* flag title */}
                  <div style={{ width: "42%" }}>{flag.title}</div>
                  {/* term placement */}
                  <div style={{ width: "12.5%" }}>
                    <Select
                      disabled={!editing}
                      size="small"
                      value={getFlagTermIndexVal(row, flag.id)}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        changeFlagIndex(parseInt(value), row, flag.id);
                      }}
                      options={[
                        { value: 0, label: "صفر" },
                        { value: 1, label: "یک" },
                        { value: 2, label: "دو" },
                        { value: 3, label: "سه" },
                        { value: 4, label: "چهار" },
                      ]}
                    />
                  </div>
                  {/* flag importance */}
                  <div style={{ width: "12.5%" }}>
                    <Select
                      disabled={!editing}
                      size="small"
                      value={getFlagImportance(row, flag.id)}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        changeFlagImportance(parseInt(value), row, flag.id);
                      }}
                      options={[
                        { value: 0, label: "صفر" },
                        { value: 1, label: "یک" },
                        { value: 2, label: "دو" },
                        { value: 3, label: "سه" },
                      ]}
                    />
                  </div>
                  {/* stat */}
                  <div
                    style={{
                      width: "33%",
                      textAlign: "end",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "100%",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term1}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term2}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term3}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term4}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.total}
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          });

          return element;
        });
      }
    } else {
      return (
        <Space>
          <Skeleton.Input active />
          <Skeleton.Input active />
          <Skeleton.Input active />
        </Space>
      );
    }
  };

  const getFlagTermIndexVal = (row, flagId) => {
    if (row.isOption) {
      const exists = tempFlagsIndex.find(
        (i) =>
          i.id === row.id &&
          i.answer_id === row.anwser_id &&
          i.flagId === flagId
      );

      return exists?.value ?? 0;
    } else {
      let exists = tempFlagsIndex.find(
        (i) => i.id === row.id && i.flagId === flagId && !i.answer_id
      );
      if (!exists) {
        exists = tempFlagsIndex.find(
          (i) => i.answer_id === row.id && i.flagId === flagId && !i.id
        );
      }

      return exists?.value ?? 0;
    }
  };

  const getFlags = () => {
    api
      .get("/flags", { params: { page: 1, pageSize: 3000, all:true } })
      .then((res) => {
        setAllFlags(res.data.data);
      })

      .catch(() => message.error("خطا در دریافت کارت ها"));
  };

  const saveIgnoreTags = (questionId, answerId, tags) => {
    api
      .post("/question-ignore-tag", {
        questionId,
        answerId,
        tags,
        formId: formId,
      })
      .then(() => {})
      .catch(() => message.error("خطا در ثبت تگ ها"))
      .finally(() => getFlagIgnoreTags(formId));
  };

  const saveIgnoreFlags = (questionId, answerId, flagsId) => {
    api
      .post("/question-ignore-flag", {
        questionId,
        answerId,
        flagsId,
        formId: formId,
      })
      .then(() => {})
      .catch(() => message.error("خطا در ثبت کارت های حذفی"))
      .finally(() => getIgnoreFlagsList(formId));
  };

  const loadFormAdjectives = () => {
    api
      .get(`/question-adjective/all`)
      .then((res) => {
        setFormAdjectives(res.data);
      })
      .catch(() => message.error("خطا در دریافت صفت ها"));
  };

  const getQAAdjectives = (questionId, answerId) => {
    return formAdjectives
      .filter((e) => e.questionId == questionId && e.answerId == answerId)
      .map((e) => e.adjective);
  };

  const changeFlagIndex = (value, row, flagId) => {
    const importance = getFlagImportance(row, flagId);

    setTempFlagsIndex((prev) => {
      if (row.isOption) {
        const newArr = prev.filter(
          (i) =>
            !(
              i.answer_id === row.anwser_id &&
              i.id === row.id &&
              flagId === i.flagId
            )
        );

        return [
          ...newArr,
          {
            answer_id: row.anwser_id,
            id: row.id,
            flagId,
            value,
            importance,
          },
        ];
      } else {
        const newArr = prev.filter(
          (i) =>
            !(i.id === row.id && flagId === i.flagId && i.answer_id === null)
        );

        return [
          ...newArr,
          {
            id: row.id,
            flagId,
            value,
            importance,
          },
        ];
      }
    });
  };

  const saveQAAdjectives = (questionId, answerId, adjectives) => {
    api
      .post(`/question-adjective`, {
        formId: params.key,
        answerId,
        questionId,
        adjectives: Array.from(
          new Set((adjectives ?? []).filter((e) => e).map((e) => e.trim()))
        ),
      })
      .then((res) => {})
      .catch(() => message.error("خطا در ثبت صفت ها"))
      .finally(() => {
        loadFormAdjectives();
      });
  };

  const getFlagsTag = () => {
    api
      .get("/flags/tags")
      .then((res) => setFlagsTag(res.data))
      .catch(() => message.error("خطا در دریافت تگ ها"));
  };

  const getIgnoreFlagsOfQuestion = (questionId, answerId) => {
    const res = ignoreFlags?.filter((ignoreFlag) =>
      answerId
        ? `${ignoreFlag.question_id}` === `${questionId}` &&
          `${ignoreFlag.answer_id}` === `${answerId}`
        : `${ignoreFlag.question_id}` === `${questionId}` &&
          ignoreFlag.answer_id === null
    );

    return res ?? [];
  };

  const getIgnoreFlagsList = (id) => {
    api
      .get(`/question-ignore-flag/${id}`)
      .then(({ data }) => setIgnoreFlags(data))
      .catch(() => message.error("خطا در دریافت کارت های حذفی"));
  };

  const loadImportantQuestions = useCallback(() => {
    if (!formId) return;
    api
      .get("/important-questions", {
        params: { formId },
      })
      .then(({ data }) => {
        setImportantQuestions(data.data || []);
      })
      .catch(() => message.error("خطا در دریافت سوالات مهم"));
  }, [formId]);

  const loadFormReport = useCallback(() => {
    if (!params.key) return;
    api
      .get(`/forms/${params.key}/report`)
      .then(({ data }) => {
        setFormReport(data);
      })
      .catch(() => message.error("خطا در دریافت گزارش فرم"));
  }, [params.key]);

  const addImportantQuestion = (questionId, optionId = null) => {
    if (!formId) return;
    const payload = {
      formId,
      questionId,
      optionId,
    };

    api
      .post("/important-questions", payload)
      .then(() => {
        message.success("سوال مهم با موفقیت اضافه شد");
        loadImportantQuestions();
      })
      .catch(() => message.error("خطا در افزودن سوال مهم"));
  };

  const deleteImportantQuestion = (id) => {
    api
      .delete(`/important-questions/${id}`)
      .then(() => {
        message.success("سوال مهم با موفقیت حذف شد");
        loadImportantQuestions();
      })
      .catch(() => message.error("خطا در حذف سوال مهم"));
  };

  const isMainQuestionImportant = (questionId) => {
    if (!Array.isArray(importantQuestions) || importantQuestions.length === 0) {
      return false;
    }

    return importantQuestions.find(
      (iq) => iq.questionId == questionId && iq.optionId == null
    );
  };

  const isRecordImportant = (record) => {
    if (!Array.isArray(importantQuestions) || importantQuestions.length === 0) {
      return false;
    }

    const questionId = record.isOption ? record.anwser_id : record.id;
    const optionId = record.isOption ? record.id : null;

    // Check if this specific record is marked as important
    const isDirectlyImportant = importantQuestions.find(
      (iq) => iq.questionId == questionId && iq.optionId == optionId
    );

    // For options, also check if parent question is important
    if (record.isOption && !isDirectlyImportant) {
      return isMainQuestionImportant(questionId);
    }

    return isDirectlyImportant;
  };

  const getParentQuestion = (record) => {
    if (!record.isOption) return null;
    return data.find((q) => q.id === record.anwser_id);
  };

  const toggleImportantQuestion = (record) => {
    // Prevent toggling options to not-important if parent question is important
    if (record.isOption) {
      const parentQuestionId = record.anwser_id;
      const isParentImportant = isMainQuestionImportant(parentQuestionId);
      const isCurrentlyImportant = isRecordImportant(record);

      // If trying to remove importance from option but parent is important, prevent it
      if (isCurrentlyImportant && isParentImportant) {
        message.warning(
          "نمی‌توان اهمیت گزینه را حذف کرد در حالی که سوال اصلی مهم است"
        );
        return;
      }
    }

    const questionId = record.isOption ? record.anwser_id : record.id;
    const optionId = record.isOption ? record.id : null;

    const existingImportant = importantQuestions.find(
      (iq) => iq.questionId == questionId && iq.optionId == optionId
    );

    if (existingImportant) {
      deleteImportantQuestion(existingImportant.id);
    } else {
      addImportantQuestion(questionId, optionId);
    }
  };

  const getQuestionReport = (record) => {
    if (
      !formReport ||
      !formReport.report ||
      !Array.isArray(formReport.report)
    ) {
      return null;
    }

    // Only check for questions, not options
    if (record.isOption) {
      return null;
    }

    const questionId = record.id;
    const report = formReport.report.find(
      (r) =>
        r.questionId == questionId ||
        String(r.questionId) === String(questionId)
    );

    // Make sure the report has options data
    if (
      report &&
      report.options &&
      Array.isArray(report.options) &&
      report.options.length > 0
    ) {
      return report;
    }

    return null;
  };

  const hasQuestionReport = (record) => {
    return getQuestionReport(record) !== null;
  };

  const findFlag = (flagId) => allFlags.find((fl) => fl.id === flagId);

  const getQAAndOptionsAdjectives = (questionId) => {
    return formAdjectives
      .filter((e) => e.questionId == questionId || e.answerId == questionId)
      .map((e) => e.adjective);
  };

  const getRelation = async (id) => {
    return api.get("/flags-relation/" + id).then(({ data }) => {
      const response = data.map((i) => ({
        value: i.termIndex,
        flagId: i.flag,
        id: i.answer_id,
        answer_id: i.question_id,
        importance: i?.importance ?? 0,
      }));

      setTempFlagsIndex(response);
      return response;
    });
  };

  const getFlagIgnoreTags = (id) => {
    api
      .get(`/question-ignore-tag/${id}`)
      .then((el) => setIgnoreTags(el.data))
      .catch(() => message.error("خطا در دریافت تگ های متصل"));
  };

  const getFlagSta = (flagId) => {
    const flag = flagsStat?.find((flag) => flag.id === flagId);

    return {
      total: flag?.totalCount ?? -1,
      term1: flag?.term1 ?? -1,
      term2: flag?.term2 ?? -1,
      term3: flag?.term3 ?? -1,
      term4: flag?.term4 ?? -1,
    };
  };

  const getIgnoreTag = (questionId, answerId) => {
    return ignoreTag
      .filter((tData) =>
        answerId
          ? `${tData.answer_id}` === `${answerId}` &&
            `${tData.question_id}` === `${questionId}` &&
            `${tData.form_id}` === `${formId}`
          : `${tData.question_id}` === `${questionId}` &&
            `${tData.form_id}` === `${formId}`
      )
      .map(({ tag }) => tag);
  };
  const onNameChange = (event) => {
    setNewQuestionType(event.target.value);
  };
  const addItem = (e) => {
    e.preventDefault();
    api.post("/question-types", { title: newQuestionType }).then((res) => {
      setNewQuestionType("");
      setQuestionTypes((p) => [...p, res.data]);
      setTimeout(() => {
        newQuestionTypeInputRef.current?.focus();
      }, 0);
    });
  };

  const onSave = (row, rowData) => {
    loadQuestionsByKey(params.key, false)
      .then((questionsRef) => {
        let oldData = null;
        Array.from([...questionsRef]).forEach((item) => {
          const oldOptions = item.children;
          if (Array.isArray(oldOptions)) {
            oldOptions.forEach((oldOpt) => {
              if (oldOpt.id === row.id) {
                oldData = oldOpt;
              }
            });
          }
          if (item.id === row.id && !oldData) {
            oldData = item;
          }
        });
        LoadingSetter();

        const ignoreFlagList = getIgnoreFlagsOfQuestion(
          rowData?.isOption ? rowData?.anwser_id : rowData?.id,
          rowData?.isOption ? rowData?.id : null
        );

        saveIgnoreTags(
          rowData.id,
          rowData.anwser_id,
          // getIgnoreTag(row.id, row.anwser_id) ?? []
          rowData?.flagTag ?? []
        );

        console.log("ignoreTag", {
          ignoreTag,
          getIgnoreTag: getIgnoreTag(row.id, row.anwser_id),
          getIgnoreTag2: rowData?.flagTag ?? [],
          rowData,
        });

        saveIgnoreFlags(
          rowData?.isOption ? rowData.anwser_id : rowData.id,
          rowData?.isOption ? rowData.id : null,
          ignoreFlagList?.map((i) => i.bom_item.id) ?? []
        );

        saveQAAdjectives(rowData.anwser_id, rowData.id, rowData.qaAdjective);

        const resetFlagsArr = rowData?.flags?.map((flId) => ({
          id: flId,
          termIndex: getFlagTermIndexVal(row, flId),
          importance: getFlagImportance(row, flId),
        }));

        api.post("/question/reset-flags", {
          epollQuestionId: row.anwser_id ? row.anwser_id : row.id,
          epollAnswerId: row.anwser_id ? row.id : null,
          epoll_form: +formId,
          flagsArr: resetFlagsArr ?? [],
        });

        if (Array.isArray(rowData.types)) {
          const removes = (oldData.types ?? [])
            .map((el) => {
              let removed = true;
              rowData.types.forEach((a) => {
                if (`${el}` === `${a}`) {
                  removed = false;
                }
              });
              if (removed) {
                return el;
              }
              return null;
            })
            .filter(function (el) {
              return el != null;
            });
          const adds = rowData.types
            .map((el) => {
              let added = true;
              (oldData.types ?? []).forEach((a) => {
                if (`${el}` === `${a}`) {
                  added = false;
                }
              });
              if (added) {
                return el;
              }
              return null;
            })
            .filter(function (el) {
              return el != null;
            });
          if (Array.isArray(removes)) {
            let counter = 0;
            const req = () => {
              const remove = removes[counter];
              if (remove) {
                api
                  .post("/question/removequestiontype", {
                    epollQuestionId: row.anwser_id ? row.anwser_id : row.id,
                    epollAnswerId: row.anwser_id ? row.id : null,
                    questionTypeId: remove,
                    epollConnection: false,
                  })
                  .then(() => {
                    if (counter === removes.length - 1) {
                      ClearLoading();
                    } else {
                      counter++;
                      req();
                    }
                  })
                  .catch(() => {
                    ClearLoading();
                    editError();
                  });
              }
            };
            req();
          }
          if (Array.isArray(adds)) {
            let counter = 0;
            const req = () => {
              const add = adds[counter];
              if (add) {
                api
                  .post("/question/addquestiontype", {
                    epollQuestionId: row.anwser_id ? row.anwser_id : row.id,
                    epollAnswerId: row.anwser_id ? row.id : null,
                    questionTypeId: add,
                    epollConnection: false,
                  })
                  .then(() => {
                    if (counter === adds.length - 1) {
                      ClearLoading();
                    } else {
                      counter++;
                      req();
                    }
                  })
                  .catch(() => {
                    ClearLoading();
                    editError();
                  });
              }
            };
            req();
          }
        } else {
          ClearLoading();
        }
      })
      .finally(() => {
        setTimeout(() => {
          getRelation(formId);
          ClearLoading();
        }, 5000);
      });
  };

  const exportData = () => {
    const all = [];
    data.forEach((question) => {
      // first questions
      all.push({
        سوال: question.title,
        گزینه: "",
        "نام کارت": "",
        جایگاه: "",
        "ستون اول": "",
        "ستون دوم": "",
        "ستون سوم": "",
        "ستون چهارم": "",
        مجموع: "",
      });
      // flags
      const re = question?.flags?.map((fl) => {
        const flagRef = findFlag(fl);
        const flagStat = getFlagSta(fl);

        return {
          سوال: "",
          گزینه: "",
          "نام کارت": flagRef?.title ?? fl,
          جایگاه: getFlagTermIndexVal(question, fl),
          "ستون اول": flagStat.term1,
          "ستون دوم": flagStat.term2,
          "ستون سوم": flagStat.term3,
          "ستون چهارم": flagStat.term4,
          مجموع: flagStat.total,
        };
      });
      all.push(...(re ?? []));

      question.children?.forEach((child) => {
        all.push({
          سوال: "",
          گزینه: child.title,
          "نام کارت": "",
          جایگاه: "",
          "ستون اول": "",
          "ستون دوم": "",
          "ستون سوم": "",
          "ستون چهارم": "",
          مجموع: "",
        });
        const re2 = child?.flags?.map((fl) => {
          const flagRef = findFlag(fl);
          const flagStat = getFlagSta(fl);
          return {
            سوال: "",
            گزینه: "",
            "نام کارت": flagRef?.title ?? fl,
            جایگاه: getFlagTermIndexVal(child, fl),
            "ستون اول": flagStat.term1,
            "ستون دوم": flagStat.term2,
            "ستون سوم": flagStat.term3,
            "ستون چهارم": flagStat.term4,
            مجموع: flagStat.total,
          };
        });
        all.push(...(re2 ?? []));
      });
    });

    ExportExcel(all.flat(1), "سوالات");
  };

  const getReportParams = (record) => ({
    formId: params.key,
    questionId: record.isOption ? record.anwser_id : record.id,
    answerId: record.isOption ? record.id : null,
    isEpoll: false,
  });

  const downloadReportExcel = async (record) => {
    if (reportExportKey !== null) return;
    const reportParams = getReportParams(record);
    setReportExportKey(`${reportParams.questionId}-${reportParams.answerId}`);
    try {
      const { data } = await api.get("/question/textual-answers/excel", {
        params: reportParams,
        responseType: "blob",
      });
      saveAs(
        data,
        `answers-${reportParams.formId}-${reportParams.questionId}${
          reportParams.answerId == null ? "" : `-${reportParams.answerId}`
        }.xlsx`
      );
    } catch {
      message.error("خطا در دانلود گزارش پاسخ کاربران");
    } finally {
      setReportExportKey(null);
    }
  };

  const loadReport = (record) => {
    setReportData([]);

    LoadingSetter();
    return api
      .get("/question/textual-answers", {
        params: getReportParams(record),
      })
      .then((res) => {
        setReportData(res.data);
      })
      .catch((err) => message.error("خطا در دریافت جواب کاربران"))
      .finally(() => ClearLoading());
  };

  const accessToReport = useMemo(
    () => CheckPermission("answers_report", permissions),
    [permissions]
  );

  const accessToCompare = useMemo(
    () => CheckPermission("compare_questions", permissions),
    [permissions]
  );

  const reportColumns = [
    {
      title: "نام",
      dataIndex: "firstname",
      width: "15%",
      searchable: true,
    },
    {
      title: "نام خانوادگی",
      dataIndex: "lastname",
      width: "15%",
      searchable: true,
    },
    // ignore tags
    {
      title: "پاسخ",
      dataIndex: "answer",
      align: "center",
      searchable: true,
    },
  ];
  const compareColumns = [
    {
      title: "گزینه سوال اصلی",
      dataIndex: "mainOption",
      width: "25%",
    },
    {
      title: "تعداد پاسخ‌دهندگان",
      dataIndex: "totalRespondents",
      width: "20%",
    },
    {
      title: "توزیع پاسخ سوال دوم",
      dataIndex: "breakdown",
      render: (rows) => {
        if (!rows || rows.length === 0) return "-";
        return (
          <Space direction="vertical" size="small">
            {rows.map((row, idx) => (
              <div key={row?.option?.id ?? `breakdown-${idx}`}>
                {row?.option?.label || "-"}: {row?.count ?? 0} (
                {typeof row?.percentage === "number"
                  ? row.percentage.toFixed(1)
                  : row?.percentage ?? 0}
                %)
              </div>
            ))}
          </Space>
        );
      },
    },
  ];
  const compareTableData = useMemo(() => {
    if (!Array.isArray(compareResult?.comparisons)) return [];

    return compareResult.comparisons.map((item, index) => ({
      key: item?.mainOption?.id ?? `comparison-${index}`,
      mainOption: item?.mainOption?.label || "-",
      totalRespondents: item?.totalRespondents ?? 0,
      breakdown: item?.breakdown ?? [],
    }));
  }, [compareResult]);
  const openCompareModal = (question) => {
    setCompareModal(question);
    setCompareQuestionId(undefined);
    setCompareResult(null);
  };
  const handleCompareQuestions = () => {
    if (!compareModal || !compareQuestionId) {
      message.error("لطفا سوال دوم را انتخاب کنید");
      return;
    }

    setCompareLoading(true);
    api
      .get("/forms/compare-questions", {
        params: {
          mainQuestionId: compareModal.id,
          compareQuestionId,
        },
      })
      .then((res) => {
        const result = res.data?.data || res.data;

        if (!Array.isArray(result?.comparisons)) {
          setCompareResult(null);
          message.error("پاسخ نامعتبر از سرور دریافت شد");
          return;
        }

        setCompareResult(result);

        if (result.comparisons.length === 0) {
          message.info("نتیجه مقایسه خالی است");
        }
      })
      .catch((err) => {
        setCompareResult(null);
        const status = err?.response?.status;
        const serverMessage = err?.response?.data?.error?.message;

        if (status === 403) {
          message.error("دسترسی مقایسه سوالات برای شما فعال نیست");
        } else if (status === 400 && serverMessage) {
          message.error(serverMessage);
        } else {
          message.error("خطا در دریافت نتیجه مقایسه");
        }
      })
      .finally(() => setCompareLoading(false));
  };
  const columns = [
    {
      title: "سوال",
      dataIndex: "title",
      width: "13%",
      // filters: [{ value: 'hasOption' , text: 'گزینه‌دار' } , { value: 'noOption' , text: 'بدون گزینه'}],
      // onFilter: (value, record) => {
      //     if (value==='hasOption') {
      //       return Array.isArray(record.children)
      //     }
      //     if (value==='noOption') {
      //       return !Array.isArray(record.children)
      //     }
      // },
      searchable: true,
      editable: false,
    },
    {
      title: "مهم",
      dataIndex: "important",
      width: "4%",
      filters: [
        { value: true, text: "مهم" },
        { value: false, text: "غیر مهم" },
      ],
      onFilter: (value, record) => {
        return !!isRecordImportant(record) === value;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          const isImportant = isRecordImportant(record);
          const isParentImportant = record.isOption
            ? isMainQuestionImportant(record.anwser_id)
            : false;
          const parentQuestion = getParentQuestion(record);
          const isDisabled =
            record.isOption && isParentImportant && isImportant;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <ExclamationCircleOutlined
                style={{
                  color: isImportant ? "red" : "gray",
                  fontSize: "16px",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.6 : 1,
                }}
                onClick={() => {
                  if (!isDisabled) {
                    toggleImportantQuestion(record);
                  }
                }}
              />
            </div>
          );
        }
      },
      render: (value, record) => {
        const isImportant = isRecordImportant(record);
        const isParentImportant = record.isOption
          ? isMainQuestionImportant(record.anwser_id)
          : false;

        const isDisabled = record.isOption && isParentImportant && isImportant;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <ExclamationCircleOutlined
              style={{
                color: isImportant ? "red" : "gray",
                fontSize: "16px",
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.6 : 1,
              }}
              onClick={() => {
                if (!isDisabled) {
                  toggleImportantQuestion(record);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      title: "نوع",
      dataIndex: "types",
      filters: questionTypes.map((q) => {
        return { value: q.id, text: q.title };
      }),
      onFilter: (value, record) => {
        if (record.types) {
          return record.types.includes(value);
        } else {
          return true;
        }
      },
      width: "7%",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable && !record.isOption) {
          return (
            <Select
              showSearch={false}
              showArrow
              placeholder="انتخاب کنید"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space
                    style={{
                      padding: "0 8px 4px",
                    }}
                  >
                    <Input
                      placeholder="نام نوع جدید"
                      ref={newQuestionTypeInputRef}
                      value={newQuestionType}
                      onChange={onNameChange}
                    />
                    <Button
                      type="dashed"
                      icon={<PlusOutlined />}
                      onClick={addItem}
                    />
                  </Space>
                </>
              )}
              mode="multiple"
            >
              {questionTypes.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.title}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (ids, row) => {
        return Array.from(new Set(ids))
          .map((id) => questionTypes.find((es) => es.id == id))
          .filter((e) => e)
          .map((el) => <Tag>{el.title}</Tag>);
      },
    },
    // ignore tags
    {
      title: "حذف بر پایه تگ",
      dataIndex: "flagTag",
      width: "9%",
      filterSearch: true,
      filters: flagsTag.map((q) => {
        return { value: q, text: q };
      }),
      onFilter: (value, record) => {
        const tags = getIgnoreTag(record.id, record.anwser_id);

        record?.children?.forEach((child) => {
          const childTags = getIgnoreTag(child.id, record.id);
          tags.push(...childTags);
        });

        return tags?.indexOf(value) !== -1;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (record.children) return;
        if (isEditable && record.isOption) {
          const tags = getIgnoreTag(record.id, record.anwser_id);
          return (
            <Select
              defaultValue={tags}
              showSearch={true}
              showArrow
              placeholder="انتخاب کنید"
              mode="multiple"
            >
              {flagsTag.map((tag) => {
                return (
                  <Select.Option key={tag} value={tag}>
                    {tag}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (ids, row) => {
        if (row.children) {
          for (const child of row.children) {
            const childTags = getIgnoreTag(child.id, child.anwser_id);
            if (childTags.length > 0) {
              return <Tag color="blue">دارد</Tag>;
            }
          }
          return <Tag color="red">ندارد</Tag>;
        }

        const tags = getIgnoreTag(row.id, row.anwser_id);

        if (tags.length === 0) return <Tag color="red">ندارد</Tag>;

        return tags.map((a) => <Tag>{a}</Tag>);
      },
    },
    // ignore flags
    {
      title: "کارت های حذفی",
      width: "9%",
      filterSearch: true,
      filters: (allFlags ?? [])?.map((fl) => ({
        value: fl.id,
        text: fl.title,
      })),
      onFilter: (value, record) => {
        const ignoreFlagList = getIgnoreFlagsOfQuestion(record?.id, null);

        record?.children?.forEach((child) => {
          const childTags = getIgnoreFlagsOfQuestion(record?.id, child.id);
          ignoreFlagList.push(...childTags);
        });

        return ignoreFlagList.find((el) => el?.bom_item?.id === +value);
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable && record.isOption) {
          const ignoreFlagList = getIgnoreFlagsOfQuestion(
            record?.isOption ? record?.anwser_id : record?.id,
            record?.isOption ? record?.id : null
          );

          return (
            <>
              <Button
                onClick={() => {
                  setOpenIgnoreFlagModal(true);
                  setEditingRecord({
                    ...record,
                    ignoreFlags: [...(record?.ignoreFlags ?? [])],
                  });
                }}
              >
                انتخاب
              </Button>

              {ignoreFlagList?.map((a) => (
                <Tag>{a?.bom_item?.title}</Tag>
              ))}
            </>
          );
        }
      },
      render: (ids, row) => {
        const ignoreFlagList = getIgnoreFlagsOfQuestion(
          row?.isOption ? row?.anwser_id : row?.id,
          row?.isOption ? row?.id : null
        );

        const childFlagList = [];
        if (ignoreFlagList?.length === 0) {
          row?.children?.forEach((child) => {
            const childTags = getIgnoreFlagsOfQuestion(row?.id, child.id);
            childFlagList.push(...childTags);
          });

          if (childFlagList.length === 0) {
            return <Tag color="red">ندارد</Tag>;
          }
          return <Tag color="blue">دارد</Tag>;
        }

        return ignoreFlagList?.map((a) => <Tag>{a?.bom_item?.title}</Tag>);
      },
    },
    {
      title: "صفات",
      dataIndex: "qaAdjective",
      width: "7%",
      filterSearch: true,
      filterMultiple: false,
      filters: adjectiveList.map((q) => {
        return { value: q, text: q };
      }),
      onFilter: (value, record) => {
        return getQAAndOptionsAdjectives(record.id).includes(value);
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          const adjectives = getQAAdjectives(record.anwser_id, record.id);
          return (
            <Select
              defaultValue={adjectives}
              showSearch={true}
              showArrow
              placeholder="انتخاب کنید"
              mode="tags"
            >
              {adjectiveList.map((adj) => {
                return (
                  <Select.Option key={adj} value={adj}>
                    {adj}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (_, row) => {
        const adjectives = getQAAdjectives(row.anwser_id, row.id);
        if (adjectives.length === 0) return <Tag color="red">ندارد</Tag>;

        return adjectives.map((a) => <Tag>{a}</Tag>);
      },
    },

    // flags
    {
      title: "کارت‌ها",
      dataIndex: "flags",
      width: "25%",
      filters:
        Array.isArray(allFlags) &&
        allFlags.map((flag) => {
          return {
            value: flag.id,
            text: flag.title,
            ...flag,
          };
        }),
      filterSearch: true,
      onFilter: (value, record) => {
        if (Array.isArray(record.allFlags)) {
          let has = false;
          record.allFlags.forEach((el) => {
            if (el === value) {
              has = true;
            }
          });
          return has;
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <div>
              <Button
                onClick={() => {
                  setOpenModal(true);
                  setEditingRecord(record);
                }}
              >
                انتخاب
              </Button>

              <div>
                {/* header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.05)",
                    height: "3rem",
                    marginTop: "0.3rem",
                    paddingLeft: "0.5rem",
                    paddingRight: "0.5rem",
                  }}
                >
                  {/* flag title */}
                  <div style={{ width: "42%", fontWeight: "bold" }}>کارت</div>

                  {/* term placement */}
                  <div
                    style={{
                      width: "12.5%",
                      fontWeight: "bold",
                      textAlign: "center",
                      transform: "translateX(1.2rem)",
                    }}
                  >
                    جایگاه
                  </div>

                  {/* flag importance */}
                  <div
                    style={{
                      width: "12.5%",
                      fontWeight: "bold",
                      textAlign: "center",
                      transform: "translateX(1.2rem)",
                    }}
                  >
                    اهمیت
                  </div>

                  {/* stat */}
                  <div
                    style={{
                      width: "33%",
                      textAlign: "end",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      آمار
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        یک
                      </div>
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        دو
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        سه
                      </div>
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        چهار
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        جمع
                      </div>
                    </div>
                  </div>
                </div>
                {flagsMapper(record.flags, record, true)}
              </div>
            </div>
          );
        }
      },

      render: (ids, row) => {
        return flagsMapper(ids, row);
      },
    },
    {
      title: "گزارش",
      dataIndex: "report",
      align: "center",
      width: "7%",
      render: (ids, row) => {
        if (!accessToReport) {
          return "-";
        }
        const hasReport = hasQuestionReport(row);
        const canCompare =
          !row.isOption && Array.isArray(row.children) && row.children.length;
        return (
          <Space wrap className={styles.ReportActions}>
            <Button onClick={() => setReportModal(row)}>مشاهده</Button>
            {CheckPermission("textual_answers_download", permissions) && (
              <Button
                loading={reportExportKey === `${row.isOption ? row.anwser_id : row.id}-${row.isOption ? row.id : null}`}
                disabled={reportExportKey !== null}
                onClick={() => downloadReportExcel(row)}
              >
                اکسل
              </Button>
            )}
            {accessToCompare && (
              <Button
                disabled={!canCompare}
                onClick={() => openCompareModal(row)}
              >
                مقایسه
              </Button>
            )}
            {hasReport && (
              <Button
                type="text"
                icon={<EqualizerIcon />}
                onClick={() => setStatisticsModal(row)}
                style={{ color: "#1890ff" }}
                title="آمار و نمودار"
              />
            )}
          </Space>
        );
      },
    },
    {
      title: "گزینه دارای کارت",
      dataIndex: "optionsHasFlag",
      filters: [
        { value: true, text: "دارد" },
        { value: false, text: "ندارد" },
      ],
      onFilter: (value, record) => {
        return record.optionsHasFlag === value;
      },
      width: "6%",
      align: "center",
      editable: false,
      render: (value, row) => {
        if (row.isOption) {
          return;
        }
        return value === true ? (
          <Tag color="blue" style={{ width: "100%", textAlign: "center" }}>
            دارد
          </Tag>
        ) : (
          <Tag color="red" style={{ width: "100%", textAlign: "center" }}>
            ندارد
          </Tag>
        );
      },
    },
  ];

  const removeFlagHandler = (record) => {
    const newData = data;
    const newRecord = editingRecord;
    const flags = newRecord.flags;
    let index = null;
    flags.forEach((flag, i) => {
      if (flag === record.id) {
        index = i;
      }
    });
    newRecord.flags.splice(index, 1);
    const finalData = newData.map((el) => {
      if (el.id === newRecord.id) {
        return newRecord;
      }
      return el;
    });
    setData(finalData);
  };
  const onSelectFlagHandler = (record, selected) => {
    if (selected) {
      const newData = Array.from([...data]);
      const newRecord = editingRecord;
      newRecord.flags.push(record.id);
      let finalData = [];
      if (newRecord.anwser_id) {
        finalData = newData.map((el) => {
          if (el.id === newRecord.anwser_id) {
            const children = el.children.map((child) => {
              if (child.id === newRecord.id) {
                return newRecord;
              }
              return child;
            });
            return { ...el, children };
          }
          return el;
        });
      } else {
        finalData = newData.map((el) => {
          if (el.id === newRecord.id) {
            return newRecord;
          }
          return el;
        });
      }

      setData(finalData);
    } else {
      removeFlagHandler(record);
    }
  };
  const onSelectFlagForIgnoreHandler = (record, selected) => {
    const qaId = editingRecord?.isOption
      ? editingRecord.anwser_id
      : editingRecord.id;
    const answerId = editingRecord?.isOption ? editingRecord.id : null;

    const cc = getIgnoreFlagsOfQuestion(
      editingRecord?.isOption ? editingRecord?.anwser_id : editingRecord?.id,
      editingRecord?.isOption ? editingRecord?.id : null
    )
      .map((a) => a?.bom_item?.id)
      .filter((e) => e);

    const ignoreFlagsSet = new Set([
      ...(editingRecord?.ignoreFlags ?? []),
      ...cc,
    ]);
    if (selected) {
      ignoreFlagsSet.add(record.id);
    } else {
      ignoreFlagsSet.delete(record.id);
    }

    setEditingRecord({
      ...editingRecord,
      ignoreFlags: Array.from(ignoreFlagsSet),
    });

    setData((prevData) =>
      prevData?.map((rec) => {
        if (rec.id !== editingRecord.id) return rec;

        return {
          ...rec,
          ignoreFlags: Array.from(ignoreFlagsSet),
        };
      })
    );

    // update temp flag ignore list

    const newAppendFlags = Array.from(ignoreFlagsSet).map((flId) => {
      const flag = findFlagRef({ id: flId }, allFlags);

      return { bom_item: flag, question_id: qaId, answer_id: answerId };
    });

    const newDt = ignoreFlags.filter(
      (prev) => prev.question_id !== qaId && prev.answer_id !== answerId
    );

    newDt.push(...newAppendFlags);

    setIgnoreFlags(newDt);
  };

  const findRelatedFlagsOfQa = (qaId, optId, relationList) => {
    return relationList
      .filter((el) => el.answer_id === qaId && el.id === optId)
      .map((e) => e.flagId);
  };

  const loadQuestionsByKey = async (key, shouldSet = true) => {
    return api.get(`/forms/${key}`).then(async (res) => {
      const relationList = await getRelation(res.data.id);

      setQuestionTypes([...res.data.allTypes]);

      const totalList = [];
      res.data.questions.forEach((e) => {
        if (
          (e?.questions ?? [])?.length > 0 &&
          e.field_type === "multidropdown"
        ) {
          totalList.push(
            ...e?.questions.map((el) => ({
              ...el,
              label:
                `${el.parentIndex}.${el.index}` +
                " - " +
                el.parentLabel +
                " => " +
                el.label,
            }))
          );
        }

        totalList.push({
          ...e,
          label:
            e.field_type !== "html" && e.field_type !== "break"
              ? e.index + " - " + e.label
              : e.label,
        });
      });

      const newQa = totalList
        .map((qa) => {
          const allFlags = findRelatedFlagsOfQa(qa.id, null, relationList);
          qa?.options?.forEach((opt) => {
            allFlags.push(
              ...(findRelatedFlagsOfQa(qa.id, opt.id, relationList) ?? [])
            );
          });

          return {
            id: qa.id,
            key: qa.id,
            question_type: qa.field_type,
            title: getPlainLabel(qa.label ?? ""),
            types: qa.types,
            flags: findRelatedFlagsOfQa(qa.id, null, relationList),
            allFlags: allFlags,
            optionsHasFlag:
              (qa.options ?? []).filter(
                (opt) =>
                  (findRelatedFlagsOfQa(qa.id, opt.id, relationList) ?? [])
                    .length > 0
              ).length !== 0,
            children:
              !qa.options || qa.options.length === 0
                ? null
                : qa.options?.map((ans) => {
                    return {
                      anwser_id: qa.id,
                      id: ans.id,
                      key: ans.id,
                      title: ans.label,
                      types: ans.types,
                      flags: findRelatedFlagsOfQa(qa.id, ans.id, relationList),
                      isOption: true,
                    };
                  }),
          };
        })
        .filter((e) => e);

      if (shouldSet) {
        setFormId(res.data.id);
        getFlagIgnoreTags(res.data.id);
        getIgnoreFlagsList(res.data.id);
        setData(newQa.filter((e) => e.question_type !== "multidropdown"));
      }

      return newQa;
    });
  };

  const getFlagsReport = () => {
    api.get("/flags/report").then((el) => setFlagStat(el.data.data));
  };

  const loadData = () => {
    LoadingSetter();
    loadQuestionsByKey(params.key)
      .catch(() => message.error("خطا در دریافت سوالات"))
      .finally(() => ClearLoading());
    getFlags();
    getFlagsReport();
    getFlagsTag();
  };

  useEffect(() => {
    loadData();
    loadFormAdjectives();
    loadFormReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (formId) {
      loadImportantQuestions();
    }
  }, [formId, loadImportantQuestions]);

  useEffect(() => {
    if (reportModal) {
      loadReport(reportModal);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [reportModal]);

  useEffect(() => {
    loadFormReport();
  }, [params.key, loadFormReport]);

  return (
    <>
      <div
        style={{
          width: "100%",
          justifyContent: "end",
          display: "flex",
          paddingTop: "1rem",
          paddingLeft: "1rem",
        }}
      >
        <Button
          onClick={() => navigate(`/question/${params.key}`)}
          style={{ width: "10rem" }}
        >
          سوالات
        </Button>
      </div>

      <div className={styles.QuestionsTable}>
        <DataTable
          dataSource={data}
          hideComment
          hideErrorReport
          setDataSource={setData}
          editable
          keepPageOnSave
          columns={columns}
          editableKeys={editableKeys}
          setEditableRowKeys={setEditableRowKeys}
          onSave={onSave}
          permissionsPrefix="flags"
          reload={loadData}
          recordCreatorDisabled
          // rowClassName={(record) =>
          //   [
          //     record.anwser_id ? styles.AwnserRow : null,
          //     record.question_type === "break" ? styles.Break : null,
          //   ].join(" ")
          // }
          rowClassName={(record) => {
            const classes = [];
            if (
              Array.isArray(importantQuestions) &&
              importantQuestions.length > 0
            ) {
              const isImportant = isRecordImportant(record);
              if (isImportant) {
                classes.push("row_error");
              }
            }

            return [
              record.anwser_id ? styles.AwnserRow : null,
              record.question_type === "break" ? styles.Break : null,
              ...classes,
            ].join(" ");
          }}
          onRowEditable={(record) =>
            record.question_type === "break" ? false : true
          }
          header={{
            title: params.title,
            avatar: { icon: <ApiOutlined />, size: "large" },
            extra: CheckPermission("export_excel", permissions) && (
              <Button onClick={exportData} disabled={data.length === 0}>
                خروجی اکسل
              </Button>
            ),
          }}
        />
      </div>

      {/* connect flags modal */}
      <Modal
        title={editingRecord && editingRecord.title}
        destroyOnClose
        centered
        width="100%"
        open={openModal}
        onOk={() => setOpenModal(false)}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Flags
          rowSelection={{
            hideSelectAll: true,
            onSelect: onSelectFlagHandler,
            selectedRowKeys: editingRecord
              ? Array.isArray(editingRecord.flags)
                ? editingRecord.flags.map((flag) => {
                    return flag;
                  })
                : null
              : null,
          }}
        />
      </Modal>

      {/* ignore flags modal */}
      <Modal
        title={editingRecord?.title}
        destroyOnClose
        centered
        width="100%"
        open={openIgnoreFlagModal}
        onOk={() => setOpenIgnoreFlagModal(false)}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Flags
          rowSelection={{
            hideSelectAll: true,
            onSelect: onSelectFlagForIgnoreHandler,
            selectedRowKeys: getIgnoreFlagsOfQuestion(
              editingRecord?.isOption
                ? editingRecord?.anwser_id
                : editingRecord?.id,
              editingRecord?.isOption ? editingRecord?.id : null
            )
              .map((a) => a?.bom_item?.id)
              .filter((e) => e),
          }}
        />
      </Modal>

      {/* report modal */}
      <Modal
        destroyOnClose
        centered
        width="100%"
        open={reportModal?.id}
        onCancel={() => setReportModal(false)}
        footer={null}
        title={""}
      >
        <DataTable
          recordCreatorDisabled
          header={{}}
          dataSource={reportData}
          setDataSource={setReportData}
          columns={reportColumns}
          hideComment
          hideErrorReport
          editable={false}
          permissionsPrefix="flags"
          reload={loadData}
        />
      </Modal>

      {/* compare questions modal */}
      <Modal
        destroyOnClose
        centered
        width="90%"
        open={!!compareModal}
        onCancel={() => setCompareModal(null)}
        footer={[
          <Button key="close" onClick={() => setCompareModal(null)}>
            بستن
          </Button>,
          <Button
            key="compare"
            type="primary"
            onClick={handleCompareQuestions}
            disabled={!compareQuestionId}
            loading={compareLoading}
          >
            مقایسه
          </Button>,
        ]}
        title="مقایسه سوالات"
      >
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <div>
            <Typography.Text strong>سوال اصلی: </Typography.Text>
            {compareModal?.title}
          </div>
          <Select
            showSearch
            allowClear
            placeholder="سوال دوم (گزینه‌دار) را انتخاب کنید"
            value={compareQuestionId}
            optionFilterProp="children"
            onChange={(value) => {
              setCompareQuestionId(value);
              setCompareResult(null);
            }}
          >
            {selectableQuestions
              .filter((q) => q.id !== compareModal?.id)
              .map((q) => (
                <Select.Option key={q.id} value={q.id}>
                  {q.title}
                </Select.Option>
              ))}
          </Select>
          {compareResult && (
            <Space direction="vertical" style={{ width: "100%" }} size="small">
              <Typography.Text>
                سوال اصلی:{" "}
                {compareModal?.title ||
                  compareResult?.mainQuestion?.label ||
                  ""}
                {compareResult?.mainQuestion?.question_number &&
                  ` (${compareResult?.mainQuestion?.question_number})`}
              </Typography.Text>
              <Typography.Text>
                سوال مقایسه:{" "}
                {selectableQuestions.find((q) => q.id === compareQuestionId)
                  ?.title ||
                  compareResult?.compareQuestion?.label ||
                  ""}
                {compareResult?.compareQuestion?.question_number &&
                  ` (${compareResult?.compareQuestion?.question_number})`}
              </Typography.Text>
              {compareTableData.length > 0 ? (
                <Table
                  columns={compareColumns}
                  dataSource={compareTableData}
                  pagination={false}
                  loading={compareLoading}
                  rowKey="key"
                />
              ) : (
                <div>
                  <Typography.Text type="secondary">
                    داده‌ای برای نمایش وجود ندارد
                  </Typography.Text>
                  {process.env.NODE_ENV === "development" && (
                    <Typography.Text
                      type="secondary"
                      style={{
                        display: "block",
                        marginTop: 8,
                        fontSize: "12px",
                      }}
                    >
                      Debug: compareResult ={" "}
                      {JSON.stringify(compareResult, null, 2)}
                    </Typography.Text>
                  )}
                </div>
              )}
            </Space>
          )}
        </Space>
      </Modal>

      {/* statistics modal */}
      <Modal
        destroyOnClose
        centered
        width="900px"
        open={!!statisticsModal}
        onCancel={() => {
          setStatisticsModal(null);
          if (pieChartRef.current) {
            d3.select(pieChartRef.current).selectAll("*").remove();
          }
        }}
        footer={[
          <Button key="close" onClick={() => setStatisticsModal(null)}>
            بستن
          </Button>,
        ]}
        title={
          statisticsModal
            ? `گزارش آماری: ${
                getQuestionReport(statisticsModal)?.questionLabel ||
                statisticsModal.title
              }`
            : ""
        }
      >
        {statisticsModal && (
          <StatisticsModalContent
            record={statisticsModal}
            report={getQuestionReport(statisticsModal)}
            pieChartRef={pieChartRef}
          />
        )}
      </Modal>
    </>
  );
};

const { Title, Text } = Typography;

const StatisticsModalContent = ({ record, report, pieChartRef }) => {
  useEffect(() => {
    if (
      !report ||
      !report.options ||
      !Array.isArray(report.options) ||
      report.options.length === 0
    ) {
      return;
    }

    const chartElement = pieChartRef.current;
    if (!chartElement) return;

    // Clear previous chart
    d3.select(chartElement).selectAll("*").remove();

    const width = 400;
    const height = 400;
    const radius = Math.min(width, height) / 2 - 20;

    const svg = d3
      .select(chartElement)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2},${height / 2})`);

    const color = d3
      .scaleOrdinal()
      .domain(report.options.map((_, i) => i))
      .range(d3.schemeCategory10);

    const pie = d3
      .pie()
      .value((d) => d.count)
      .sort(null);

    const arc = d3.arc().innerRadius(0).outerRadius(radius);

    const outerArc = d3
      .arc()
      .innerRadius(radius * 0.9)
      .outerRadius(radius * 0.9);

    const arcs = svg
      .selectAll(".arc")
      .data(pie(report.options))
      .enter()
      .append("g")
      .attr("class", "arc");

    arcs
      .append("path")
      .attr("d", arc)
      .attr("fill", (d, i) => color(i))
      .style("stroke", "#fff")
      .style("stroke-width", 2);

    // Add labels
    arcs
      .append("text")
      .attr("transform", (d) => {
        const pos = outerArc.centroid(d);
        const midAngle = d.startAngle + (d.endAngle - d.startAngle) / 2;
        pos[0] = radius * 1.2 * (midAngle < Math.PI ? 1 : -1);
        return `translate(${pos})`;
      })
      .attr("text-anchor", (d) => {
        const midAngle = d.startAngle + (d.endAngle - d.startAngle) / 2;
        return midAngle < Math.PI ? "start" : "end";
      })
      .text(
        (d) => `${d.data.optionLabel}: ${d.data.count} (${d.data.percentage}%)`
      )
      .style("font-size", "12px")
      .style("fill", "#333");

    // Add percentage labels on slices
    arcs
      .append("text")
      .attr("transform", (d) => `translate(${arc.centroid(d)})`)
      .attr("text-anchor", "middle")
      .text((d) => (d.data.percentage > 5 ? `${d.data.percentage}%` : ""))
      .style("font-size", "14px")
      .style("font-weight", "bold")
      .style("fill", "#fff");

    return () => {
      if (chartElement) {
        d3.select(chartElement).selectAll("*").remove();
      }
    };
  }, [report, pieChartRef]);

  if (!report) {
    return <div>گزارش آماری برای این سوال موجود نیست</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <div style={{ marginBottom: "20px" }}>
            <Title level={4}>{report.questionLabel}</Title>
            <Text type="secondary">شماره سوال: {report.questionNumber}</Text>
            <br />
            <Text type="secondary">نوع: {report.fieldType}</Text>
          </div>
        </Col>
        <Col span={24}>
          <Row gutter={16}>
            <Col span={8}>
              <Statistic
                title="کل پاسخ‌ها"
                value={report.totalAnswers}
                valueStyle={{ color: "#1890ff" }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="تعداد گزینه‌ها"
                value={report.options?.length || 0}
                valueStyle={{ color: "#52c41a" }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="نوع سوال"
                value={report.fieldType}
                valueStyle={{ color: "#722ed1" }}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider>نمودار دایره‌ای</Divider>
          <div
            ref={pieChartRef}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          />
        </Col>
        <Col span={24}>
          <Divider>جزئیات گزینه‌ها</Divider>
          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            {report.options?.map((option, index) => (
              <div
                key={option.optionId}
                style={{
                  padding: "12px",
                  marginBottom: "8px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <Text strong>{option.optionLabel}</Text>
                  <br />
                  <Text type="secondary">شناسه: {option.optionId}</Text>
                </div>
                <div style={{ textAlign: "left" }}>
                  <Tag color="blue">{option.count} پاسخ</Tag>
                  <Tag color="green">{option.percentage}%</Tag>
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    flags: state.flags,
    questionTypesData: state.questionTypes,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
    // loadData: (epollformid) => dispatch(actions.getDatabase(epollformid)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionsToFlagsLocal);
